module.exports = [
  {
    showOnHome:false,
    maxSize: 4,
    isPaid: false,
    name: 'trial',
    cost: {
      GBP: {
        price: 0,
        priceText: 'Free',
      },
      EUR: {
        price: 0,
        priceText: 'Free',
      },
      USD: {
        price: 0,
        priceText: 'Free',
      }
    },
    title: 'Trial Game',
    sizeText: 'Trial Game (Up to 4 players)',
    description: 'Want to check it out? Try out the game with a fixed set of races'
  },
  {
    showOnHome:true,
    maxSize: 5,
    isPaid: false,
    name: 'small',
    cost: {
      GBP: {
        price: 5,
        priceText: '£5'
      },
      EUR: {
        price: 6,
        priceText: '€6',
      },
      USD: {
        price: 7,
        priceText: '$7 USD',
      }
    },
    title: 'Small Group',
    sizeText: 'Up to 5 players',
    description: 'Just a small gathering?'
  },
  {
    showOnHome:true,
    maxSize: 10,
    paddleId: 650145,
    isPaid: true,
    name: 'medium',
    cost: {
      GBP: {
        price: 10,
        priceText: '£10',
      },
      EUR: {
        price: 12,
        priceText: '€12',
      },
      USD: {
        price: 14,
        priceText: '$14 USD',
      }
    },
    title: 'Get Together',
    sizeText: 'Up to 10 players',
    description: 'Get your mates together and get down the races'
  },
  {
    showOnHome:true,
    maxSize: 20,
    paddleId: 650265,
    isPaid: true,
    name: 'large',
    cost: {
      GBP: {
        price: 20,
        priceText: '£20',
      },
      EUR: {
        price: 24,
        priceText: '€24',
      },
      USD: {
        price: 28,
        priceText: '$28 USD',
      }
    },
    title: 'Party Time',
    sizeText: 'Up to 20 players',
    description: 'Perfect for birthday parties and team meet ups.'
  },
  {
    showOnHome:true,
    maxSize: 400,
    paddleId: 662401,
    isPaid: true,
    name: 'custom',
    cost: {
      GBP: {
        pricePerPlayer: '1',
        priceText: '£1 / person',
      },
      EUR: {
        pricePerPlayer: '1.2',
        priceText: '€1.20 / person',
      },
      USD: {
        pricePerPlayer: 1.4,
        priceText: '$1.40 / person',
      }
    },
    title: 'Conference',
    sizeText: 'Up to 400 players',
    description: 'Running an event?'
  },
]

